export default __webpack_public_path__ + "static/media/grafema_recta-intencao-book_06.9aee1e47.jpg";